import { cn } from "@gettactic/helpers";
import React from "react";
import { Box, Flex } from "../../../primitives";
import { ConfirmModal } from "../ConfirmModal";
import { DeleteConfirmModalProps } from "./DeleteConfirmModal.types";

export const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  message: userMessage,
  confirmText = "",
  onOpenChange,
  confirmProps,
  footerProps,
  ...props
}) => {
  const [inputConfirmText, setInputConfirmText] = React.useState("");

  const onClose = () => {
    setInputConfirmText("");
    onOpenChange?.(false);
  };

  return (
    <ConfirmModal
      confirmProps={{
        variant: "destructive",
        disabled: inputConfirmText !== confirmText,
        ...confirmProps
      }}
      footerProps={{
        ...footerProps,
        className: cn(
          "justify-between flex-row-reverse",
          footerProps?.className
        )
      }}
      message={
        <Flex className={"flex-col gap-8"}>
          <Box>{userMessage}</Box>
          {confirmText && (
            <>
              <Box>
                Please type <strong>"{confirmText}"</strong> in the field below,
                then click red button to continue.
              </Box>
              {/*<Input
                className={'w-full'}
                placeholder={confirmText}
                inputProps={{ className: 'text-center' }}
                onChange={(e) => setInputConfirmText(e.target.value || '')}
              />*/}
            </>
          )}
        </Flex>
      }
      onOpenChange={(isOpen) => !isOpen && onClose()}
      {...props}
    />
  );
};
